module.exports = __webpack_public_path__ + "static/media/SPECTRIO_DARK_BG.9bf1c24c.png";